import React from "react";
import PropTypes from "prop-types";
import { Trans } from "react-i18next";
import CateringTable from "../../shared/catering/CateringTable";
import {
  selectCompany,
  selectCompanyRegistration
} from "../../../redux/preferences/selectors";
import { connect } from "react-redux";
import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import CateringCostOverviewButton from "../../shared/catering/CateringCostOverviewButton";

class _CompanyCateringOverview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static propTypes = {
    registration: PropTypes.object,
    company: PropTypes.object
  };

  render() {
    const { registration, company } = this.props;

    return [
      <AdminSubHeader title="Catering" key="subheader" breadcrumbs={[]} />,
      <div className="m-content" key="content">
        <div className="row">
          <div className="col-xl-12">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <span className="m-portlet__head-icon">
                      <i className="flaticon-tea-cup" />
                    </span>
                    <h3 className="m-portlet__head-text">Catering Overview</h3>
                  </div>
                </div>
                <div className="m-portlet__head-tools">
                  <form>
                    <ul className="m-portlet__nav m--margin-left-20">
                      <li className="m-portlet__nav-item">
                        {registration.sendCateringInvoice && (
                          <CateringCostOverviewButton
                            registration={registration}
                          />
                        )}
                      </li>
                    </ul>
                  </form>
                </div>
              </div>
              <div className="m-portlet__body">
                {company && company.completed ? (
                  <div>
                    <div className="alert alert-info">
                      <Trans>CateringRequestMsg</Trans>
                    </div>
                    <CateringTable registration={registration} admin />
                  </div>
                ) : (
                  <div className="alert alert-danger">
                    <Trans>
                      Please complete your company information before requesting
                      catering
                    </Trans>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    ];
  }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = function(state) {
  return {
    registration: selectCompanyRegistration(state),
    company: selectCompany(state)
  };
};

const CompanyCateringOverview = connect(
  mapStateToProps,
  mapDispatchToProps
)(_CompanyCateringOverview);

export default CompanyCateringOverview;
